import { Flex, Heading, View, Alert, } from '@smarterservices/smarter-ui';
import SinglePane from '../../../SinglePane';
import {VerificationInput} from '../../../VerificationInput';
import { useEffect, useState } from 'react';
import Loader from '../../../Common/Loader';
import { useAppStore } from '../../../../stores/app';
import {config} from '../../../../config';

const SecondCameraCodePrompt = ({ setIsTaskComplete }) => {
  const [userInput, setUserInput] = useState('');
  const [codeToCheck, setCodeToCheck] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { initializeAppFromStash } = useAppStore();
    
  useEffect(() => {
    const checkCode =  async () => {
      try{
        await initializeAppFromStash({code: codeToCheck, type: 'second-camera'});
        // if successful, add the code to the query string in the URL
        const url = new URL(window.location.href);
        url.searchParams.set('code', codeToCheck);
        window.history.replaceState(null, '', url.toString());
        setCodeToCheck('');
      }catch(error){
        setErrorMessage("The device link code entered is invalid. Please try again.");
        setCodeToCheck('');
      }  
    }

    if(codeToCheck.length === config.session.secondCamera.codeLength){
      checkCode();
    }    
  }, [codeToCheck]);
  
  return (
    <SinglePane>
       <Flex as="div" direction="column" alignItems="center" justifyContent="center" height="100%">
        {codeToCheck === '' ? (
          <>
          {errorMessage.length > 0 && (
            <Alert
              variant="error"
              title="Invalid device link code"
              description={errorMessage}
              margin="0 0 medium 0"
            >{errorMessage}</Alert>  
          )}
          <Heading level="h3">Enter your device link code</Heading>
          <View as="div" padding="medium">
            <VerificationInput
              characterType="alphanumeric"
              length={config.session.secondCamera.codeLength}
              splitText="-"
              value={userInput}
              onChange={setUserInput}
              onComplete={(value) => {
                setCodeToCheck(value);
              }}
            />
        </View>
        </>
        ):(
          <Loader text="Validating..." />
        )}
      </Flex>
    </SinglePane>
  );
};

export default SecondCameraCodePrompt;
